import React from 'react';
import moment from 'moment';
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const SalesOrderInvoiceTable = (props) => {

  const classes = useStyles();

  return (
    <TableContainer>
      <Divider/>
      { props.products.length > 0 ?
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Product ID</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Product Brand</TableCell>
            <TableCell align="right">Selling Price</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.products.map((product) => (
            <TableRow key={product.displayId}>
              <TableCell component="th" scope="row">
                {product.displayId}
              </TableCell>
              <TableCell component="th" scope="row">{product.name}</TableCell>
              <TableCell component="th" scope="row">{product.company}</TableCell>
              <TableCell align="right">{product.sellPrice}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table> : null }
      <br></br>
      <Divider/>
      { props.payments.length > 0 ?
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Payment Invoice ID</TableCell>
            <TableCell>Payment Date</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell>Payment Method</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.payments.map((payment) => (
            <TableRow key={payment.displayId}>
              <TableCell component="th" scope="row">
                {payment.displayId}
              </TableCell>
              <TableCell component="th" scope="row">{moment(payment.createdAt).format('DD/MM/YYYY')}</TableCell>
              <TableCell align="right">{payment.amount}</TableCell>
              <TableCell component="th" scope="row">{payment.paymentMethod}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table> : null }
    </TableContainer>
  )
};

export default SalesOrderInvoiceTable;